import React from 'react';
import styles from './styles.module.css';

const LoadingPage: React.FC = () => {
    return (
        <div className={styles.loader}></div>
    );
};

export default LoadingPage;
